import React from 'react';
import './App.css';
import Todo from './components/Todo';

function App() {
  return (
    <div className="app">
      <Todo />
    </div>
  );
}

export default App;
